import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App container">
      <Weather />
      <footer>
        This project was coded by Yoeshabat Makwara and is{" "}
        <a
          href="https://github.com/Yoesh118/react-weather-app"
          rel="noreferrer"
          target="_blank"
        >
          open-sourced
        </a>
      </footer>
    </div>
  );
}

export default App;
